export function distinct<T>(): (value: T, index: number, self: T[]) => boolean {
    return function (value, index, self) {
        return self.indexOf(value) === index;
    }
}